module.exports = __webpack_public_path__ + "assets/img/33_162.027b5cfa.jpg";